module.exports = __webpack_public_path__ + "assets/img/teacher (4).f8feda0c.png";